import gql from 'graphql-tag'

export const ADD_USER_COMPETENCY = gql`
  mutation ($competency: learning_diary_competencies_insert_input!) {
    insert_learning_diary_competencies_one(object: $competency) {
      id
    }
  }
`
